import { useLoadState } from 'app-components/hooks/utils';
import { useEffect, useReducer, useRef } from 'react';

// The purpose of this hook is to initialize the reducer with the correct value from redux and to update once we have
// the correct value
// NOTE: There is currently no option for multiple load states - we will cross this bridge when we get to it

export default function useLazyLoadReducer(reducer, initialPayload, initFunc, selectors) {
  const view = useLoadState(selectors);
  const isInitial = useRef(view !== 'READY' && view !== 'READY_UPDATE' && view !== 'EMPTY');

  // we want access to whether state is initialized, so we are auto-magically adding state variable isInitialized
  function internalInitFunc(isInitialized) {
    return function internalRet(payload) {
      return { ...initFunc(payload), isInitialized };
    };
  }

  function internalReducer(state, action) {
    if (action.type === 'INITIALIZE') {
      return internalInitFunc(true)(action.payload);
    }
    return reducer(state, action);
  }

  const [state, dispatch] = useReducer(internalReducer, initialPayload, internalInitFunc(isInitial.current));

  useEffect(() => {
    if ((view === 'READY' || view === 'READY_UPDATE' || view === 'EMPTY') && isInitial.current) {
      isInitial.current = false;
      dispatch({ type: 'INITIALIZE', payload: initialPayload });
    }
  }, [view, isInitial, initialPayload]);

  return [state, dispatch];
}
